import React from 'react'
import SharedBulkImportSessionsContent from '../../../components/BulkImportSessionsContent'

interface Props {
  onTotalChange?: (total: number) => void
  refreshSignal?: number
  pollingRefreshSignal?: number
  defaultPageSize?: number
  onPageSizeChange?: (size: number) => void
}

export default function BulkImportSessionsContent({
  onTotalChange,
  refreshSignal,
  pollingRefreshSignal,
  defaultPageSize,
  onPageSizeChange,
}: Props) {
  return (
    <SharedBulkImportSessionsContent
      overrideType="plan-benefit"
      onTotalChange={onTotalChange}
      refreshSignal={refreshSignal}
      pollingRefreshSignal={pollingRefreshSignal}
      defaultPageSize={defaultPageSize}
      onPageSizeChange={onPageSizeChange}
    />
  )
}
